import swal from "sweetalert";

export type ErrorDialogProps = {
  title: string;
  content?: string;
  cb?: Function;
}
export const ErrorDialog = ({ title, content, cb }: ErrorDialogProps) => {
  swal(title, content ? content : "", "error")
    .then(() => {
      if (cb) {
        cb();
      }
    });
}